export const TAB_IDS = {
  TYPE_TAB: 'type_tab',
  MAKE_MODEL_TAB: 'make_model_tab',
  PRICE_TAB: 'price_tab',
  VEHICLE_PRICE_TAB: 'vehicle_price_tab',
  LOAN_PAYMENT_TAB: 'loan_payment_tab',
  LEASE_PAYMENT_TAB: 'lease_payment_tab',
};
